import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundPageComponent } from '../../shared/pages/not-found-page.component';
import { UnauthorizedPageComponent } from '../../shared/pages/unauthorized-page.component';
import { CallbackComponent } from './component/authCallback/callback.component';
import { LoginComponent } from './component/login/login.component';

export class SecurityRoutingStates {
  public static readonly LOGIN_STATE = {
    url: 'login'
  };
  public static readonly CALLBACK_STATE = {
    url: 'callback'
  };
  public static readonly UNAUTHORIZED_STATE = {
    url: `console/unauthorized`
  };
  public static readonly PAGE_NOT_FOUND_STATE = {
    url: `console/not-found`
  };
}

export const SecurityRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: SecurityRoutingStates.LOGIN_STATE.url
  },
  {
    path: SecurityRoutingStates.LOGIN_STATE.url,
    data: {
      page: {
        title: ''
      }
    },
    component: LoginComponent,
    resolve: {}
  },
  {
    path: SecurityRoutingStates.CALLBACK_STATE.url,
    data: {
      page: {
        title: ''
      }
    },
    component: CallbackComponent
  },
  {
    path: SecurityRoutingStates.UNAUTHORIZED_STATE.url,
    data: {
      page: {
        title: ''
      }
    },
    component: UnauthorizedPageComponent
  },
  {
    path: SecurityRoutingStates.PAGE_NOT_FOUND_STATE.url,
    data: {
      page: {
        title: ''
      }
    },
    component: NotFoundPageComponent
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(SecurityRoutes)]
})
export class SecurityRoutingModule {}
